import { useClientSideDataGridModel } from "src/components/common/dataGrid/gridModel/useClientSideDataGridModel";
import { PartConfigurationBomPricesApi } from "src/api/generated/erp/configurator/api/partConfigurationBomPricesApi.ts";
import { ControlledAsyncDataGrid } from "src/components/common/dataGrid/ControlledAsyncDataGrid";
import { getPartConfigurationBomDataGridColumns } from "src/components/views/erp/configurator/inspecting/configurationBomUtils.ts";
import { PartConfigurationDetailsViewApi_PartConfigurationDto } from "src/api/generated/erp/configurator/api/partConfigurationDetailsViewApi.ts";
import { PartConfigurationBomLineInspectionDto } from "src/api/generated/erp/configurator/api/partConfigurationBomLineInspectionDto.ts";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";
import i18n from "i18next";

export interface PartConfigurationBomPricesOfGroupDataGridProps {
	partConfiguration: PartConfigurationDetailsViewApi_PartConfigurationDto;
	bomLineGroupId: number;
	vatPercent?: number;
}

export const PartConfigurationBomPricesOfGroupDataGrid = ({
	partConfiguration,
	bomLineGroupId,
	vatPercent,
}: PartConfigurationBomPricesOfGroupDataGridProps) => {
	const showCostInSellingCurrency = partConfiguration.sellingCurrencyId !== partConfiguration.domesticCurrencyId;
	const useDomesticCostForMargin = partConfiguration.sellingCurrencyId === partConfiguration.domesticCurrencyId;

	const { dataGridProps } = useClientSideDataGridModel({
		fetchData: () =>
			PartConfigurationBomPricesApi.getBomLinesInGroupRecursively({
				partConfigurationId: partConfiguration.partConfigurationId,
				bomLineGroupId: bomLineGroupId,
			}),
		getRowId: (row) => row.partConfigurationBomLineId,
		gridId: "A6F5D8E9C4F4814E",
		initialParams: {},
	});

	return (
		<ControlledAsyncDataGrid<PartConfigurationBomLineInspectionDto>
			columns={getPartConfigurationBomDataGridColumns({
				vatPercent,
				sellingCurrencyCode: partConfiguration.sellingCurrencyCode,
				domesticCurrencyCode: partConfiguration.domesticCurrencyCode,
				showCostInSellingCurrency,
				useDomesticCostForMargin,
			})}
			agentContext={{
				key: defineAgentUiContextKey("erp.configurator.partConfigurationBomPriceGroupLines.grid"),
				data: {
					partConfigurationId: partConfiguration.partConfigurationId,
					bomLineGroupId: bomLineGroupId,
				},
				rowFields: ["partConfigurationBomLineId", "partConfigurationId", "bomLinePartId", "referenceNo"],
				selectedRowPathSegment: (row) => `${i18n.t("reference_no")} ${row.referenceNo}`,
			}}
			{...dataGridProps}
		/>
	);
};
